import { Form } from 'antd';
import commaNumber from 'comma-number';

import { VFlex } from '@/components/base';
import Input from '@/components/Inputs/Input';

import { SCRAPER_REQ_FIELD_KEY } from '../../configs/scraper-field-map/field-const';

/**
 * max_items 기반 스크래퍼 전용 필드 컴포넌트
 */
export const MaxItemsField = (props: {
  required?: boolean;
  maxCount: number;
}) => {
  const { required = false, maxCount } = props;
  return (
    <Form.Item
      label="Max feedback items to collect"
      layout="vertical"
      tooltip="Note: Maximum scrapable feedback count may differ across platforms."
      labelCol={{ flex: 1 }}
      rules={[
        {
          validator: (_, value) => {
            const numberValue = Number(value);
            if (numberValue && numberValue < 1) {
              return Promise.reject(
                new Error('Max datapoints to scrap must be greater than 0'),
              );
            }
            if (numberValue && numberValue > maxCount) {
              return Promise.reject(
                new Error(
                  `Max datapoints to scrap must be less than ${commaNumber(
                    maxCount,
                  )}`,
                ),
              );
            }
            return Promise.resolve();
          },
        },
      ]}
      name={SCRAPER_REQ_FIELD_KEY.MAX_ITEMS}
      required={required}
    >
      <VFlex g={8}>
        <Input
          sizeType="m"
          placeholder={`Set limit (default: ${commaNumber(maxCount)})`}
        />
      </VFlex>
    </Form.Item>
  );
};
